import { format } from "date-fns";
import React from "react";
import { StyleSheet, Text, View, } from "react-native";
import { Icon } from "./Icon";
export const DateIndicator = ({ currentDate, dayFormat, dateFormat, formatOptions, iconColor, textStyle, }) => {
    currentDate ??= new Date();
    dayFormat ??= "EEEE";
    dateFormat ??= "MM-dd-yyyy";
    const formattedDay = format(currentDate, dayFormat, formatOptions);
    const formattedDate = format(currentDate, dateFormat, formatOptions);
    return (<View style={styles.container}>
      <Icon iconSet="material-community" icon="calendar-range-outline" size={24} color={iconColor}/>
      <View>
        <Text style={[styles.text, textStyle]}>{formattedDay}</Text>
        <Text style={[styles.text, textStyle]}>{formattedDate}</Text>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: 4,
        paddingHorizontal: 12,
        gap: 12,
        height: 32,
    },
    text: {
        fontSize: 14,
        lineHeight: 18,
    },
});
//# sourceMappingURL=DateIndicator.js.map